import * as Yup from 'yup';

export const closeCashRegisterSchema = Yup.object().shape({
  comment: Yup.string().required(),
  cash: Yup.number().optional().default(0),
  creditCard: Yup.number().optional().default(0),
  transference: Yup.number().optional().default(0),
});
